import service from '@/services/reviewRequests';

export default {
  loadReviewRequests: ({ commit, state }, { onlyWithCoupons, ...payload } = {}) => {
    return service
      .getReviewRequestsDatatables({ onlyWithCoupons, ...state.reviewRequests.pagination }, payload)
      .then(response => commit('loadReviewRequestsSuccess', response));
  },
  setPagination({ commit }, payload) {
    return commit('setPagination', payload);
  },
  sendNow: ({ dispatch, commit }, { orderId, sendSms }) => {
    //820 notes: unused variable removed
    return service
      .sendNow(orderId, sendSms)
      .then(() => {
        dispatch(
          'showToast',
          {
            type: 'success',
            message: 'ReviewRequests.sendNowSuccess',
          },
          {
            root: true,
          }
        );
        return commit('sendNowSuccess', orderId);
      })
      .catch(() => {
        dispatch(
          'showToast',
          {
            type: 'error',
            message: 'ReviewRequests.sendNowError',
          },
          {
            root: true,
          }
        );
      });
  },
  cancel: ({ commit, dispatch }, orderId) => {
    //820 notes: unused variable removed
    return service
      .cancel(orderId)
      .then(() => {
        dispatch(
          'showToast',
          {
            type: 'success',
            message: 'ReviewRequests.cancelSuccess',
          },
          {
            root: true,
          }
        );
        return commit('cancelSuccess', orderId);
      })
      .catch(() => {
        return dispatch(
          'showToast',
          {
            type: 'error',
            message: 'ReviewRequests.sendNowError',
          },
          {
            root: true,
          }
        );
      });
  },
  reschedule: ({ dispatch }, reviewRequestId) => {
    //820 notes: unused variable removed
    return service
      .reschedule(reviewRequestId)
      .then(() => {
        dispatch(
          'showToast',
          {
            type: 'success',
            message: 'ReviewRequests.sendNowSuccess',
          },
          {
            root: true,
          }
        );
      })
      .catch(() => {
        dispatch(
          'showToast',
          {
            type: 'error',
            message: 'ReviewRequests.sendNowError',
          },
          {
            root: true,
          }
        );
      });
  },
  loadReviewRequestsPerMonth: context => {
    service
      .getReviewRequestsPerMonth()
      .then(response => {
        return context.commit('loadReviewRequestsPerMonthSuccess', response);
      })
      .catch(err => {
        return context.dispatch(
          'showToast',
          {
            type: 'error',
            message: err,
          },
          {
            root: true,
          }
        );
      });
  },
  sendReviewRequestsByMonth: ({ dispatch }, payload) => {
    return service
      .sendReviewRequestsByMonth(payload)
      .then(() => {
        return dispatch(
          'showToast',
          {
            type: 'success',
            message: 'ReviewRequests.sendOldSuccess',
          },
          {
            root: true,
          }
        );
      })
      .catch(() => {
        return dispatch(
          'showToast',
          {
            type: 'error',
            message: 'ReviewRequests.bulkError',
          },
          {
            root: true,
          }
        );
      });
  },
  scheduleReviewRequestForOrder: ({ commit, dispatch }, payload) => {
    //820 notes: unused variable removed
    dispatch(
      'showToast',
      {
        type: 'success',
        message: 'ReviewRequests.scheduledSuccess',
      },
      {
        root: true,
      }
    );
    return service
      .scheduleReviewRequestForOrder(payload)
      .then(res => {
        commit('setCreditsLeft', res.data.creditsLeft, { root: true });
      })
      .catch(() => {
        return dispatch(
          'showToast',
          {
            type: 'error',
            message: 'ReviewRequests.sendNowError',
          },
          {
            root: true,
          }
        );
      });
  },
};
